import styled from 'styled-components';
import { AllieThumbnail, AllieThumbnailProps } from '../../../components/Media/Thumbnail';

interface ToolbarAssetProps {
  alwaysVisible?: boolean;
}

export const AssetsContainerStyled = styled.div`
  display: flex;
  column-gap: 1rem;
  row-gap: 1rem;
  flex-wrap: wrap;
`;

export const AssetStyled = styled.article`
  position: relative;
  border-radius: 8px;
  border: 1px solid var(--allie-color-neutral-20);
  box-sizing: border-box;
  padding: 6px 6px 0 6px;
  background-color: var(--allie-color-white);

  ion-thumbnail {
    --border-radius: 4px 4px 0 0;
  }
`;

export const ToolbarAssetStyled = styled.div<ToolbarAssetProps>`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  visibility: ${(props) => (props.alwaysVisible ? 'visible' : 'hidden')};
  display: flex;
  column-gap: 2px;

  ${AssetStyled}:hover & {
    visibility: visible;
  }
}`;

export const ButtonStyled = styled.button`
  width: 27px;
  height: 27px;
  justify-content: center;
  background-color: var(--allie-color-neutral-60);
  color: var(--allie-color-neutral-10);

  border-radius: 100px;
  padding: 0px 5px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  transition: box-shadow 250ms ease 0s, background 250ms ease 0s,
    border-color 150ms ease 0s;
  box-shadow: transparent 0px 0px 0px 0px, transparent 0px 0px 0px 0px inset;
  border: 1px solid transparent;
`;

export const NameContainerStyled = styled.div`
  height: 28px;
  width: auto;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: var(--allie-color-neutral-10);
  border-radius: 0 0 4px 4px;
  box-sizing: border-box;

  > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const AllieThumbnailStyled = styled(AllieThumbnail)`
  width: 100%;
  background-color: var(--allie-color-neutral-5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--allie-color-primary-50);
  cursor: pointer;
`;

export const AllieThumbnailUploadStyled = styled(AllieThumbnail)`
  width: ${(props: AllieThumbnailProps) => props.width}px;
  background-color: var(--allie-color-primary-2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--allie-color-primary-50);
  flex-direction: column;
  cursor: pointer;
  border: 1px dashed var(--allie-color-primary-50);
  box-sizing: border-box;
`;
